import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'umi';
import { DefaultPage } from '../tdesign';
// config
import { API } from '@/config';
// utils
import { GoogleCaptchaVersionEnum } from '@/pages/adminManage/utils/typing/login';
import { setTimeOut } from '@/utils/common';
// type
import { LanguageType, StatusTipEnum } from '@/definition/common/data.d';
import { intlGet } from '@/locales';
import { ConnectState } from '@/models/connect.d';
import { DefaultPageStatusEnum } from '../tdesign/data.d';

type PropsType = {
  localLanguage: LanguageType;
  version?: GoogleCaptchaVersionEnum;
  onChange: (val: string) => void;
  /** 加载失败 */
  onFail?: () => void;
};

function GooglCapture(props: PropsType) {
  const {
    localLanguage,
    version = GoogleCaptchaVersionEnum.V2,
    onChange,
    onFail,
  } = props;
  // google 验证码js
  const googleApi = 'https://www.google.com/recaptcha/api.js';

  const captchaRef = useRef(null);

  const [loadFlag, setLoadFlag] = useState(true);

  const [reqStatus, setReqStatus] = useState(StatusTipEnum.init);

  const lang = useMemo(() => {
    const langMap: any = {
      'en-US': 'en',
      'zh-CN': 'zh-CN',
    };
    return langMap[localLanguage] || 'en';
  }, [localLanguage]);

  const loadScriptUrl = useMemo(
    () =>
      version === GoogleCaptchaVersionEnum.V3
        ? `${googleApi}?render=${API.reCaptureV3SiteKey}`
        : `${googleApi}?render=explicit&hl=${lang}`,
    [lang, version],
  );

  // 加载js
  const loadScript = (url: string) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.defer = true;
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`));

      script.onload = () => {
        setTimeOut(() => {
          resolve({
            code: 0,
          });
        }, 1000);
      };

      document.head.appendChild(script);
    });
  };

  // 通过移除的方式，切换验证码语言
  // const removeExitScript = () => {
  //   // const scriptsTag: any = document.getElementsByTagName('head')?.[0];
  //   // for (let i = 0; i < scriptsTag.length; i++) {

  //   //   if (scriptsTag[i].getAttribute('src') === loadScriptUrl) {
  //   //     //   已存在
  //   //     scriptsTag[i].remove();
  //   //   }
  //   // }
  //   // 移除旧的reCAPTCHA脚本标签
  //   const oldScriptTag = document.querySelector(
  //     'script[src*="/recaptcha"]',
  //   );
  //   console.log("oldScriptTag", oldScriptTag);

  //   if (oldScriptTag) {
  //     oldScriptTag.remove();
  //   }
  // };
  const onCaptchaRender = () => {
    if (version === GoogleCaptchaVersionEnum.V3) {
      // @ts-ignore
      window?.grecaptcha.ready(function () {
        // @ts-ignore
        window?.grecaptcha
          .execute(API.reCaptureV3SiteKey, { action: 'submit' })
          .then(function (token: string) {
            onChange?.(token);
          });
      });
    } else {
      // @ts-ignore
      window.grecaptcha?.render(captchaRef.current, {
        sitekey: API.reCaptureV2SiteKey,
        callback: (value: any) => {
          onChange?.(value);
        },
      });
    }
  };
  // 初始化
  const onInit = () => {
    setReqStatus(StatusTipEnum.loading);
    // js 加载
    try {
      // @ts-ignore
      loadScript(loadScriptUrl)
        .then(() => {
          setReqStatus(StatusTipEnum.success);
          onCaptchaRender();
        })
        .catch(() => {
          console.error('load fail');
          setReqStatus(StatusTipEnum.error);
          onFail?.();
        });
    } catch (e) {
      setReqStatus(StatusTipEnum.error);
      onFail?.();
    }
  };

  useEffect(() => {
    if (loadFlag) {
      onInit();
    }
    return () => setLoadFlag(false);
  }, [loadFlag]);

  // useEffect(() => {
  //   return () => removeExitScript();
  // }, []);

  return version === GoogleCaptchaVersionEnum.V2 ? (
    <div className="google-capture-components">
      <div
        ref={captchaRef}
        className={classNames('hide', {
          'dp-block': reqStatus === StatusTipEnum.success,
        })}
      />
      <DefaultPage
        status={
          reqStatus === StatusTipEnum.error
            ? DefaultPageStatusEnum.NO_NETWORK
            : reqStatus
        }
        style={
          reqStatus !== StatusTipEnum.success ? { width: 304, height: 85 } : {}
        }
        containerStyle={{ lineHeight: 'normal' }}
        retryText={intlGet('COMMON.REFRESH.PAGE')}
        onRetry={() => window?.location.reload()}
      />
    </div>
  ) : (
    ''
  );
}

export default connect(({ CommonModel }: ConnectState) => ({
  localLanguage: CommonModel.localLanguage,
}))(GooglCapture);
